var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.63182C8 8.72947 7.96224 8.82311 7.89502 8.89216C7.8278 8.96121 7.73664 9 7.64158 9H0.358423C0.263363 9 0.172197 8.96121 0.10498 8.89216C0.0377623 8.82311 0 8.72947 0 8.63182C0 6.61909 2.15054 5.87618 4 5.87618C5.84946 5.87618 8 6.61909 8 8.63182ZM6.43728 2.50855C6.43633 3.00351 6.29258 3.48708 6.0242 3.89815C5.75581 4.30923 5.37483 4.62936 4.9294 4.8181C4.48396 5.00684 3.99406 5.05572 3.52159 4.95857C3.04912 4.86141 2.61528 4.62257 2.2749 4.27224C1.93452 3.92191 1.70287 3.47579 1.60921 2.99027C1.51556 2.50475 1.5641 2.0016 1.74871 1.54441C1.93332 1.08721 2.24572 0.696487 2.64642 0.4216C3.04712 0.146714 3.51816 9.51487e-07 4 0C4.64684 0.00130031 5.26676 0.266167 5.7237 0.736469C6.18065 1.20677 6.43728 1.84409 6.43728 2.50855Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserico);
export default __webpack_public_path__ + "static/media/userico.762acc41190e836bcd5177080e53d0a3.svg";
export { ForwardRef as ReactComponent };